import { showSnackbar } from '../api/snackbarSlice';
import store from '../store';

/**
 * Copies text to the system clipboard
 * @param {string} text - Text to copy to clipboard
 * @returns {Promise<boolean>} - Returns true if successful, false otherwise
 */
export const copyToClipboard = async (text) => {
  try {
    if (!navigator.clipboard) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      if (!successful) {
        throw new Error('Copy command failed');
      }
      return true;
    }

    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    store.dispatch(
      showSnackbar({
        message: 'Failed to copy to clipboard',
        severity: 'error',
      }),
    );
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};
